import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Alert,
  CircularProgress
} from '@mui/material';
import { authService } from '../services/auth.service';

interface EmailVerificationModalProps {
  isOpen: boolean;
  onClose: () => void;
  email: string;
}

const EmailVerificationModal: React.FC<EmailVerificationModalProps> = ({
  isOpen,
  onClose,
  email
}) => {
  const [isResending, setIsResending] = useState(false);
  const [resendMessage, setResendMessage] = useState('');
  const [resendSuccess, setResendSuccess] = useState(false);

  const handleResendEmail = async () => {
    setIsResending(true);
    setResendMessage('');
    setResendSuccess(false);
    
    try {
      await authService.resendVerificationEmail(email);
      setResendMessage('Email xác thực đã được gửi lại. Vui lòng kiểm tra hộp thư của bạn.');
      setResendSuccess(true);
    } catch (error: any) {
      setResendMessage(error.response?.data?.message || 'Có lỗi xảy ra khi gửi email xác thực.');
      setResendSuccess(false);
    } finally {
      setIsResending(false);
    }
  };

  console.log('EmailVerificationModal render:', { isOpen, email }); // Debug log

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        Xác thực tài khoản
      </DialogTitle>

      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Chúng tôi đã gửi email xác thực đến <strong>{email}</strong>.
        </Typography>
        
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Vui lòng kiểm tra hộp thư và nhấp vào liên kết xác thực để kích hoạt tài khoản.
        </Typography>

        {resendMessage && (
          <Alert 
            severity={resendSuccess ? 'success' : 'error'} 
            sx={{ mb: 2 }}
          >
            {resendMessage}
          </Alert>
        )}

        <Box sx={{ bgcolor: 'grey.50', p: 2, borderRadius: 1 }}>
          <Typography variant="body2" color="text.secondary">
            <strong>Lưu ý:</strong> Liên kết xác thực có hiệu lực trong 24 giờ. 
            Sau khi xác thực thành công, bạn sẽ nhận được 50 coins.
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button
          variant="contained"
          onClick={handleResendEmail}
          disabled={isResending}
          startIcon={isResending ? <CircularProgress size={16} /> : null}
        >
          {isResending ? 'Đang gửi...' : 'Gửi lại email xác thực'}
        </Button>
        
        <Button
          variant="outlined"
          onClick={onClose}
        >
          Đóng
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EmailVerificationModal; 